import { ActivatedRoute } from '@angular/router';
import { HostListener, Component, OnInit, OnDestroy, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { AppConfig } from '../../app/config/app.config';
import { ButtonBarComponent } from '../guicomponents/buttonbar/buttonbar.component';
import { ConfirmComponent } from '../dialogboxes/confirm.component';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { PackageInstructionItem, PackageIntructionPart, PkgInstrLevelInfo, PkgInstrLevelMaterialBE, PkgInstrLevelAdditionalMaterialBE, ApprovalBE, SupplierPruTypeBE, PkgInstrPruRelationBE } from './shared/packaging-instruction.model';
import { PictureBe } from '../image-library/shared/image-model';
import { ImageCommon } from '../image-library/image-common';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum, ConflictTypeEnum } from '../shared/enums.model';
import { PackageInstructionService } from './packaging-instruction.service';
import { ConfirmResult } from '../../app/dialogboxes/shared/confirm.model'
import { PartSupplierPruBe, PartListBE } from '../partsupplierpru/shared/partsupplierpru.model';
import { PartSupplierPruService } from '../partsupplierpru/partsupplierpru.service';
import { PArray } from '../shared/packit-array';
import { AttributeListBE } from '../shared/attribute-list.model';
import { UserHandling } from '../shared/user-handling';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { PackagingInstructionSelectListComponent } from './packaging-instruction-selectlist.component';
import { StatusEnum } from '../shared/enums.model';
import { NgbDateFRParserFormatter } from '../shared/ngb-date-fr-parser-formatter';
import { SupplierService } from '../../app/supplier/supplier.service';
import { DashBoardService } from '../../app/dashboard/dashboard.service';
import { PiHistoryListBE } from '../../app/dashboard/shared/dashboard.model';
import { MultiPartService } from '../../app/multipart-part/multipart-part.service';
import { ListPackagingInstructionMaterialComponent } from './list-packaging-instruction-material.component';
import { PartSearchComponent } from '../../app/part-search/part-search.component';
import { forEach } from '@angular/router/src/utils/collection';
import { EILSEQ } from 'constants';
import { PackagingMaterialAttirbuteService } from '../packaging-material-attributes/packaging-material-attributes.service';
import { parse } from 'querystring';
import { UserManagementService } from '../../app/user-management/user-management.service';
import { UserPruBE } from '../../app/user-management/shared/user-management.model';
import { ChangeIssuerService } from '../../app/change-issuer/change-issuer.service';
import { Server } from 'selenium-webdriver/safari';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { ChineseChangeValueService } from '../chinese-change-value.service';

declare var jQuery: any;

interface allRegions {
  value: number;
  viewValue: string;
}

// Same as database id from table status
const MIN_NAME_LENGTH = 7;

let PnL = 0;
let CW2 = 0;
let CPC=  0;
let piname = '';
let flagPnL = '';
//let flagCW2 = '';
let sendToSupplierVerified = false;


@Component({
    moduleId: module.id,
    selector: 'packaging-instruction',
    templateUrl: 'packaging-instruction.html',
    providers: [ChineseChangeValueService,MultiPartService, ChangeIssuerService, PackageInstructionService, PartSupplierPruService, SupplierService, DashBoardService, PackagingMaterialAttirbuteService,UserManagementService],
    styleUrls: ['packaging-instruction.css']
})

export class PackagingInstructionComponent implements OnInit, OnDestroy, ComponentCanDeactivate {
   
    chineseNumbers:string='';
    latinNumbers:string='';
    onChineseChange(Value:string)
    {
        this.chineseNumbers=Value;
        this.latinNumbers=this.ChineseToNormal(Value);
    }
    private ChineseToNormal(input: string): string {  // function for conversion of chinese numbers 

        const Chinesenumber: Record<string, number> = { 
    
          零: 0, 
    
          一: 1, 
    
          二: 2, 
    
          三: 3, 
    
          四: 4, 
    
          五: 5, 
    
          六: 6, 
    
          七: 7, 
    
          八: 8, 
    
          九: 9 
    
        }; 
    
     
    
        return input.replace(/[零一二三四五六七八九]/g, check => { 
    
          return Chinesenumber[check].toString(); 
    
        }); 
    
      }
     
      
      showDiv_value:boolean=true;
      
      

    @Input() instructionIdFromParentCtrl: number;

    selectedInstructionId: number = -1;
    user: UserHandling = new UserHandling();
    instruction: PackageInstructionItem = undefined;

    // Search PI
    fetchDataFunction: any = (searchTerm: string) => { this.loadInstructionList(searchTerm); };
    instructionsList: AttributeListBE[];

    // Confirm dialog box
    @ViewChild('cDlg') cdlg: ElementRef;
    dialogAction: string;
    dialogBtnType: string;
    dialogAppliesTo: string = "";
    dialogAppliesToId: number = -1;
    confirmDlgText: string = "";
    startDate: NgbDateStruct;
    createDate: NgbDateStruct;
    dateFormatter: NgbDateFRParserFormatter = new NgbDateFRParserFormatter();
    dateConfig: NgbDatepickerConfig = new NgbDatepickerConfig();

    // Panel header text toggle for parts, prus and suppliers info
    supplierListVisible: boolean = false;
    partListVisible: boolean = false;
    pruListVisible: boolean = false;

    // Image
    image1: any;
    imageLibraryEvent: PictureBe;//Testing variable
    pictureLabels: string = "";
    imageSearchResult: PictureBe[] = [];
    selectedImages: Array<number> = [];
    pictureIdS: Array<number> = [];
    deleteImageInfo: PictureBe;
    @Output() piImageId: Array<number> = [];
    PITitle: string = "";

    // Button bar
    btnDuplicateVisible: boolean = true;
    btnNewVisible: boolean = true;
    btnPreviewVisible: boolean = true;
    btnSaveVisible: boolean = true;
    btnApproveVisible: boolean = true;
    btnHistoryVisible: boolean = true;
    btnDeleteVisible: boolean = true;

    // Misc
    showSpinner: boolean = false;
    typeDelayTimer: any = null;
    currentDlg: NgbModalRef;
    isDirty: boolean = false;
    newInstructionText: string = null;
    unreliablePartText: string = "";

    // input action timer
    pendingAction: any = null;
    historyList: PiHistoryListBE[] = []; 1

    //history list
    @ViewChild('viewHistoryDlg') historyDlg: ElementRef;
    showHistorySpinner: boolean = true;

    // Weight and deviation
    partWeight: number = 0;
    totalPartWeight: number = 0;
    grossWeight: number = 0;
    totalPackaginWeight: number = 0;
    typeOfWeight: string = "";

    // is pi unique
    orgName: string = "";
    nameExistsClass: string = "";
    duplicatepiname: string = "";
    // send for approval
    approvalMessage: string = "";
    sendForApprovalSuppliers: PartSupplierPruBe[] = [];
    sendToSupplierOrAccept: string = "";

    @ViewChild('sendPIForAproval') approvaDlg: ElementRef;

    // Other info
    otherInfos: Array<string> = [];
    newOtherInfo: string = '';

    // Pru-supplier
    partSuppPru: PartSupplierPruBe[] = [];
    selectedPartRelationId: number = null;
    consistingParts: PartListBE[] = [];
    pruList: AttributeListBE[] = [];

    // Levels
    editLevelData: PkgInstrLevelInfo = null;
    constraintCodeId: number = null;
    hasSubLevelCode: boolean = false;
    Mhnumber: Array<string> = [];
    levelmh: Array<string> = [];
    public Exclusionlist: Array<string> = [];

    //Conflict dialog
    @ViewChild('conflictPruDlg') conflictPruDlg: ElementRef;
    conflictResponseObj: Array<PkgInstrPruRelationBE>;
    activeConflictItemId: number;
    public conflictEnums = ConflictTypeEnum;
    currentConflictDlg: NgbModalRef;

    showUnitLoadingAnimation: boolean = false;
    showSupplierRelLoadingAnim: boolean = false;
    pruUserList: UserPruBE[];
    selectedPruUser: UserPruBE = new UserPruBE();

    levelIndexes: number[] = [0, 1, 2, 3];
    flag: number = 0;
    isEdited: boolean;
    isApproved: boolean;
    selectedRegionValue: number = 3;

    allRegions: allRegions[] = [
      { value: 1, viewValue: 'Internal' },
      { value: 2, viewValue: 'One-Way' },
      { value: 3, viewValue: 'Returnable' }
    ];


    constructor(private packInstrService: PackageInstructionService,
        private partSupplierPruService: PartSupplierPruService,
        private modalService: NgbModal,
        private _route: ActivatedRoute,
        private config: AppConfig,
        private supplierService: SupplierService,
        private errHandler: ErrorHandlerService,
        private dashBoardService: DashBoardService,
        private multiPartService: MultiPartService,
        private materialAttrService: PackagingMaterialAttirbuteService,
        private dater: NgbDateParserFormatter,
        private pruUserService: UserManagementService,
        private changeIssuerService: ChangeIssuerService,
        public ChineseChangeValueService:ChineseChangeValueService) {

          this.isEdited = sessionStorage.getItem('isUser') == 'true' ? true : false
          this.isApproved = sessionStorage.getItem('isApprover') == 'true' ? true : false
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return !this.isDirty;
    }


    // ----------------------------------------------------------
    // Life cycle hooks
    // ----------------------------------------------------------
    ngOnInit(): void {
        // First check if we get here from a route containing the id
        // If its not from a route, check if the page is used as a control that passes an id
        // If its neither then abort loading
        this.getMaterialExclusions();
        this.errHandler.emitErrorObject(null);
        var id = +this._route.snapshot.params["packInstructionId"];
        if (isNaN(id) || id < 1) {
            if (!isNaN(this.instructionIdFromParentCtrl) || id > 0)
                id = this.instructionIdFromParentCtrl;
            else {
                this.instructionIdFromParentCtrl = null;
                this.showSpinner = false;
                return;
            }
        }
        this.selectedInstructionId = id; 
        this.loadInstruction();          
    }

    ngOnDestroy() {
      sessionStorage.removeItem('isUser');
      sessionStorage.removeItem('isApprover');
     }

     reset_filter() {
      this.instruction.Region = this.selectedRegionValue;
      
    }

    // ----------------------------------------------------------
    // Service calls and support methods
    // ----------------------------------------------------------
    saveInstruction() {
        this.showSpinner = true;
        this.setInstructionStartEndDate();
        this.instruction.Weight = this.totalPackaginWeight;
        this.instruction.GrossWeight = this.grossWeight;
        this.instruction.totalPartWeight=this.totalPartWeight;
        this.instruction.Region = this.selectedRegionValue;

        if (this.pruList != null) {
            this.pruList.forEach(item => {
                if (item.Selected == true) {
                    piname = piname + item.Description + ", ";
                }
            });
            if (flagPnL != "") {
                if (!piname.includes(flagPnL))
                    piname = piname + ", " + flagPnL;
            }
            flagPnL = "";
            // check for cw2 to append internal
            var cw2string = "CW2"; var cw2stringNew = "SL";
            var cw2internalstring = "SL-Internal";
            var supplierstring = "784001";
            if (piname.includes(cw2string)) {
                //check 784001 supplier if yes add internal
                if (this.partSuppPru != null) {
                    this.partSuppPru.forEach(item => {
                        if (item.PruMCCodeName == cw2string && item.SupplierNo == supplierstring && item.Selected == true)
                            piname = piname.replace(cw2string, cw2internalstring);
                    });
                }
            }

            //clear earlier appended consuming areas and re add updated
            if (this.instruction.PIName.includes("--")) {
                this.instruction.PIName = this.instruction.PIName.substring(0, this.instruction.PIName.indexOf("--", 0));
            }

            piname = this.instruction.PIName + "-- " + piname;
            if (piname.endsWith(", ")) {
                piname = piname.slice(0, -2);
            }

            piname = piname.replace(", ,", ",");
            this.instruction.PIName = piname

            piname = "";
            cw2string = "";
            cw2internalstring = "";
            supplierstring = "";
        }

        this.updateOtherInfo();
        let tempInstr: PackageInstructionItem = this.preparePkgInstrToPost();
        this.packInstrService.saveInstruction(tempInstr)
            .subscribe(returnObject => this.saveInstructionResponse(returnObject));
    }

    saveInstructionResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.saveResponse', returnObject.ErrorType);
        }
        else {
            this.info("The instruction was saved successsfully");
            this.setLoadedValues(returnObject);
            this.isDirty = false;
        }
        this.showSpinner = false;
        this.newInstructionText = null;
    }

    preparePkgInstrToPost(): PackageInstructionItem {
        // Cant delete the picture in instruction because it will then disappear from screen.
        // Alas, we save the instruction in a temp var and remove the bit stream in PictureImage
        // before sending to server.`
        let tempInstr: PackageInstructionItem = JSON.parse(JSON.stringify(this.instruction));
        for (var i = 0; i < tempInstr.Pictures.length; i++)
            tempInstr.Pictures[i].PictureImage = null;

        return tempInstr;
    }

    deleteInstruction() {
        let deleteMessage = "Deleted reason"
        this.currentDlg.close();
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.packInstrService.deleteInstruction(this.instruction.Id, deleteMessage, this.user.UserId)
            .subscribe(returnObject => this.deleteInstructionResponse(returnObject));
    }

    deleteInstructionResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.deleteInstructionResponse', returnObject.ErrorType);
        }
        else {
            if (returnObject.DataList[0].Id == -1) {
                this.info("The material was deleted");
                this.selectedInstructionId = null;
                this.setNewInstructionData();
            }
            else {
                this.info("The packaging instruction was scrapped");
                this.setLoadedValues(returnObject);
            }
        }
        this.showSpinner = false;
    }

    deletePart(partId: number): void {
        this.unreliablePartText = "";
        this.errHandler.emitErrorObject(null);
        this.currentDlg.close();
        let pArr: PArray<PackageIntructionPart> = new PArray(this.instruction.Parts);
        pArr.removAtIndex(pArr.getIndexByProperty('Id', partId));
        this.instruction.PartRelations = [];
        this.partSuppPru = [];
        this.setDirty();
        this.setQuantityInLevel();
        this.clearPruListSelections();
    }

    checkSupplierContactsExist() {
        this.showSpinner = true;
        let suppNos: string[] = [];
        this.prepareApprovalDlg();

        if (this.sendForApprovalSuppliers != null) {
            for (var i = 0; i < this.sendForApprovalSuppliers.length; i++) {
                if (this.sendForApprovalSuppliers[i].Selected)
                    suppNos.push(this.sendForApprovalSuppliers[i].SupplierNo);
            }
            this.sendToSupplierOrAccept = "send";
        }

        if (suppNos.length == 0) {
            this.sendToSupplierOrAccept = "activate";
            this.currentDlg = this.modalService.open(this.approvaDlg, {
                size: 'sm',
                backdrop: 'static',
                keyboard: false
            });
            this.showSpinner = false;
        }
        else {
            this.supplierService.existsContactsForSendForApproval(suppNos.join(","))
                .subscribe(returnObject => this.checkSupplierContactsExistResponse(returnObject));
        }
    }

    checkSupplierContactsExistResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.checkSupplierContactsExistResponse', returnObject.ErrorType);
        } else {
            this.sendToSupplierOrAccept = "send";
            this.currentDlg = this.modalService.open(this.approvaDlg, {
                size: 'sm',
                backdrop: 'static',
                keyboard: false
            });
        }
        this.showSpinner = false;
    }


    approveInstruction() {
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);

        let approvalBE: ApprovalBE = new ApprovalBE();
        approvalBE.ActivateNow = this.instruction.StatusId == StatusEnum.Active ? true : false;
        approvalBE.Part = this.instruction.Parts[0].PartNo + " " + this.instruction.Parts[0].Description;
        approvalBE.InstructionId = this.instruction.Id;
        approvalBE.Message = this.approvalMessage;
        approvalBE.UserId = this.user.UserId;
        approvalBE.StartDate = this.instruction.StringStartDate;
        approvalBE.InstructionType = 1;
        approvalBE.Region = this.instruction.Region;
        if (this.partSuppPru != null) {
            this.partSuppPru.forEach(x => {
                if (x.Selected)
                    approvalBE.SupplierPruTypeList.push(new SupplierPruTypeBE(x.SupplierNo, x.PruId));
            })
        }
        // environment.production
        //TODO Do we need to use StartDate more than reading, otherwise use strings and handle in backend?
        this.packInstrService.sendPackagingInstructionForApproval(approvalBE)
            .subscribe(returnObject => this.sendPackagingInstructionForApprovalResponse(returnObject));
    }

    sendPackagingInstructionForApprovalResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType == ErrorTypeEnum.Error) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.sendPackagingInstructionForApprovalResponse', returnObject.ErrorType);
        } else {
            this.currentDlg.close();

            this.setLoadedValues(returnObject);
            if (returnObject.ErrorMsg.length > 0)
                this.info(returnObject.ErrorMsg);
            else
                this.info("The packaging instruction was successfully sent to the supplier(s)");
        }
        this.showSpinner = false;
    }


    openInstruction(piId: number) {
        this.selectedInstructionId = piId;
        this.pendingAction = this.loadPi;
        //this.selectedRegionValue = this.instruction.Region
        this.countinueWithoutSave();
    }

    loadInstruction() {
        this.showSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
               this.packInstrService.getInstruction(this.selectedInstructionId)
            .subscribe(returnObject => this.loadInstructionResponse(returnObject));
    }

    loadInstructionResponse(returnObject: IReturnObject) {
        this.instruction = null;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadInstructionResponse', returnObject.ErrorType);
        else
            this.setLoadedValues(returnObject);
    }

    loadInstructionList(searchTerm: string) {
        this.instructionsList = null;
        this.packInstrService.getInstructionList(searchTerm, this.user.SupplierNumber, this.user.ExtendedSupplierNumber, this.user.IsPartSupplierUser, this.user.InstructionType)
            .subscribe(returnObject => this.loadInstructionListResponse(returnObject));
    }

    loadInstructionListResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadInstructionListResponse', ErrorTypeEnum.Error);
        }
        else {
            this.instructionsList = <AttributeListBE[]>returnObject.DataList;
        }
    }

    setLoadedValues(returnObject: IReturnObject) {
        this.selectedInstructionId = returnObject.DataList[0].Id;
        this.instruction = <PackageInstructionItem>returnObject.DataList[0];
        this.selectedRegionValue = this.instruction.Region
        this.instruction.Parts = <PackageIntructionPart[]>returnObject.DataList[0].Parts;
        this.unreliablePartText = "";
        this.loadPruList();
        this.loadSearchPruList();
        this.setInstructionDatesOnLoad();
        this.extractImages();
        this.loadOtherInfos();
        this.newInstructionText = null;

        this.showSpinner = false;
        this.orgName = this.instruction.PIName;
        this.nameExistsClass = "";
        this.duplicatepiname = "";
        this.isDirty = false;
        this.instruction.MessageInfo = this.removeDuplicateValidationStatus();
        this.setQuantityInLevel();
        this.findUserPruId();
                //check for issuer approver
        if (returnObject.DataList[0].IssuerUserId != "" && returnObject.DataList[0].IssuedByUserName == "-" && returnObject.DataList[0].IssuedByDepartment == "-")
            this.errHandler.emitError("Issuer " + returnObject.DataList[0].IssuerUserId.toUpperCase() + " doesnt exists in AD, Kindly raise a issue through Customer support to replace user " + returnObject.DataList[0].IssuerUserId.toUpperCase() + " in PackIT.", '', ErrorTypeEnum.Error);

        if (returnObject.DataList[0].ApproverUserId != "" && returnObject.DataList[0].ApprovedByUserName == "-" && returnObject.DataList[0].ApprovedByDepartment == "-")
            this.errHandler.emitError("Approver " + returnObject.DataList[0].ApproverUserId.toUpperCase() + " doesnt exists in AD, Kindly raise a issue through Customer support to replace user " + returnObject.DataList[0].ApproverUserId.toUpperCase() + " in PackIT.", '', ErrorTypeEnum.Error);
    }


    loadOtherInfos() {
        if (this.instruction.Comment != null && this.instruction.Comment.trim().length > 0)
            this.otherInfos = this.instruction.Comment != null ? this.instruction.Comment.trim().split("|") : "".split("|");
        else
            this.otherInfos = [];
    }

    removeDuplicateValidationStatus() {
        let unique = this.instruction.MessageInfo.filter(function (elem, index, self) {
            return index == self.indexOf(elem);
        })
        return unique;
    }


    createDuplicate() {
        this.instruction.Id = -1;
        this.unreliablePartText = "";

        //pi name to be fetched from db post duplicate check
        this.newInstructionText = this.instruction.nextPIname;
        this.instruction.IssuedAt = this.user.Department;
        this.instruction.StringStartDate = this.dateFormatter.toDateStringYYYYMMDDHHMI(new Date(Date.now()));
        this.instruction.StringCreatedDate = this.dateFormatter.toDateStringYYYYMMDDHHMI(new Date(Date.now()));
        this.instruction.IssuedByDepartment = this.user.Department;
        this.instruction.IssuedByUserName = this.user.UserName;
        this.instruction.IssuedByEmail=this.user.Email
        this.instruction.ApprovedByDepartment = "";
        this.instruction.ApprovedByUserName = "";
        this.instruction.PIName = this.newInstructionText;
        this.instruction.StatusId = 1;
        this.instruction.StatusDescription = "Preliminary";
        this.instruction.Version = 1
        this.instruction.IssuerUserId = this.user.UserId;
        this.instruction.ApproverUserId = "";
        this.orgName = this.instruction.PIName;
        this.nameExistsClass = "";
        this.isDirty = true;
        this.showSpinner = false;
        this.instruction.SendPreliminaryToMona = false;
        this.instruction.Region = 3;
        this.setStartEndCalenderValues();
    }

    setInstructionStartEndDate() {
        this.instruction.StringStartDate = this.dateFormatter.format(this.startDate);
        this.instruction.StringCreatedDate = this.dateFormatter.format(this.createDate)
    }

    setStartEndCalenderValues() {
        this.startDate = this.dateFormatter.parse(this.instruction.StringStartDate);
        this.createDate = this.dateFormatter.parse(this.instruction.StringCreatedDate);
    }

    setInstructionDatesOnLoad() {
        if (this.instruction.PiCreatedDate == null) {
            this.instruction.PiCreatedDate = new Date(Date.now());
            this.instruction.StringCreatedDate = this.instruction.PiCreatedDate.toISOString();
            this.setStartEndCalenderValues();
        }
        else {
            this.setStartEndCalenderValues();
        }
    }

    setNewInstructionData() {
        this.showSpinner = true;
        this.unreliablePartText = "";
        this.instruction = new PackageInstructionItem();
        this.instruction.CategoryDescription = "Packaging Instruction";
        this.instruction.IssuedAt = this.user.Department;
        this.instruction.IssuedByEmail=this.user.Email
        this.instruction.StringStartDate = this.dateFormatter.toDateStringYYYYMMDDHHMI(new Date(Date.now()));
        this.instruction.StringCreatedDate = this.dateFormatter.toDateStringYYYYMMDDHHMI(new Date(Date.now()));
        this.instruction.IssuedByDepartment = this.user.Department;
        this.instruction.IssuedByUserName = this.user.UserName;
        this.instruction.LevelInfo.push(new PkgInstrLevelInfo(1));
        this.instruction.LevelInfo.push(new PkgInstrLevelInfo(2));
        this.instruction.LevelInfo.push(new PkgInstrLevelInfo(3));
        this.instruction.LevelInfo.push(new PkgInstrLevelInfo(99));
        this.instruction.StatusDescription = "Preliminary";
        this.instruction.IssuerUserId = this.user.UserId;
        this.isDirty = true;
        this.showSpinner = false;
        this.pictureLabels = "";
        this.partSuppPru = [];
        this.otherInfos = [];
        this.newInstructionText = "NEW";
        this.orgName = "";
        this.nameExistsClass = "";
        this.setStartEndCalenderValues();
        this.clearPruListSelections();
        this.clearSelectedRegion();
    }


    // ----------------------------------------------------------
    // Images handling
    // ----------------------------------------------------------
    extractImages() {
        this.pictureIdS = [];
        ImageCommon.SetBase64Image(this.instruction.Pictures);
        this.instruction.Pictures.forEach(x => this.pictureIdS.push(x.Id));
        this.pictureLabels = ImageCommon.setPictureLabels(this.instruction.Pictures);
        this.PITitle = this.instruction.PIName;
        this.piImageId = this.pictureIdS;
    }

    selectImageToInstr(addedImage: any) {
        if (this.selectedImages.indexOf(addedImage.Id) === -1) {
            this.selectedImages.push(addedImage.Id);
            this.imageSearchResult.push(addedImage);
        } else {
            this.selectedImages.splice(this.selectedImages.indexOf(addedImage), 1);
            this.imageSearchResult.splice(this.imageSearchResult.indexOf(addedImage.Id), 1);
        }
    }

    addImageToInstruction() {
        for (var i = 0; i < this.selectedImages.length; i++) {
            if (this.pictureIdS.indexOf(this.selectedImages[i]) === -1) {
                var imageObj = this.imageSearchResult.find(x => x.Id === this.selectedImages[i]);
                this.instruction.Pictures.push(imageObj);
            }
        }

        this.refreshPictureIds();
        ImageCommon.setPictureLabels(this.instruction.Pictures);
        this.imageSearchResult = [];
        this.closeAddImageDlg();
        this.info("Image's added.");
        this.setDirty();
    }

    deleteImageFromInstruction(imageId: number) {
        ImageCommon.RemovePic(this.instruction.Pictures, imageId);
        this.refreshPictureIds();
        this.pictureLabels = ImageCommon.setPictureLabels(this.instruction.Pictures);
        this.info("The picture was removed from the instruction.");
        this.closeDeleteImageDlg();
        this.setDirty();
    }

    refreshPictureIds() {
        this.pictureIdS = []
        this.instruction.Pictures.forEach(x => this.pictureIdS.push(x.Id));
    }
    // ----------------------------------------------------------
    // History
    // ----------------------------------------------------------
    loadHistory() {
        this.dashBoardService.getHistoryFor(this.selectedInstructionId, this.user.SupplierNumber)
            .subscribe(returnObject => this.loadHistoryResponse(returnObject));
    }

    loadHistoryResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadHistoryResponse', returnObject.ErrorType);

        else {
            this.historyList = returnObject.DataList;
            this.showHistorySpinner = false;
        }
    }


    // ----------------------------------------------------------
    // Weight and deviation
    // ----------------------------------------------------------
    setWeights() {
        this.partWeight = (this.instruction.Parts != null && this.instruction.Parts.length > 0)
            ? this.instruction.Parts[0].Weight
            : 0;

        this.totalPartWeight = this.partWeight * this.getLevel1QuantityIn() * this.getLevel1QuantityOf();
        this.totalPackaginWeight = this.getAdditionalMaterialWeight() + this.getCodeMaterialWeight();
        this.grossWeight = this.totalPartWeight + this.totalPackaginWeight;
        if(this.partWeight > 0)
        {
            if(this.partWeight === this.instruction.Parts[0].MeasuredWeight)
            this.typeOfWeight = "Measured Weight";
            else if(this.partWeight === this.instruction.Parts[0].CalculatedWeight)
            this.typeOfWeight = "Calculated Weight";
            else if(this.partWeight === this.instruction.Parts[0].EstimatedWeight)
            this.typeOfWeight = "Estimated Weight";
            else if(this.partWeight === this.instruction.Parts[0].SupplierWeight)
            this.typeOfWeight = "Supplier Weight";
            else this.typeOfWeight = "Weight";
        }
    }

    getLevel1QuantityIn() {
        return this.instruction.LevelInfo[0].QuantityInLevel;
    }

    getLevel1QuantityOf() {
        return this.instruction.LevelInfo[0].QuantityOfLevel;
    }

    getAdditionalMaterialWeight(): number {
        let weight: number = 0;
        for (let level of this.instruction.LevelInfo) {
            for (let material of level.AdditionalMaterials)
                weight += material.Quantity * material.Weight;
        }
        return weight;
    }

    getCodeMaterialWeight(): number {
        let weight: number = 0;
        for (let level of this.instruction.LevelInfo) {
            for (let material of level.CodeMaterials) {
                weight += level.QuantityOfLevel * material.Quantity * material.Weight;
            }
        }
        return weight;
    }

    getMaxLenth(): number {
        return this.instruction.LevelInfo[0].Length;
    }

    getMaxWidth(): number {
        return this.instruction.LevelInfo[0].Width;
    }

    getMaxHeight(): number {
        return this.instruction.LevelInfo[0].Height;
    }


    // ----------------------------------------------------------
    // Level helpers
    // ----------------------------------------------------------
    setQuantityInLevel() {
        let levels = this.instruction.LevelInfo;
        if (levels[0].PackagingCode.length == 0)
            this.resetLevelProperties();

        levels[1].QuantityInLevel = this.getLevel3Quantity() == 0
            ? levels[1].QuantityInLevel
            : this.getLevel3Quantity();

        levels[0].QuantityInLevel = this.getLevel2Quantity() == 0
            ? levels[0].QuantityInLevel
            : this.getLevel2Quantity();

        this.setWeights();
    }

    resetLevelProperties() {
        for (let i = 0; i < this.instruction.LevelInfo.length; i++) {
            let additionalMtrl = this.instruction.LevelInfo[i].AdditionalMaterials;
            let level = i < 3 ? i + 1 : 99
            this.instruction.LevelInfo[i] = new PkgInstrLevelInfo(level);
            this.instruction.LevelInfo[i].AdditionalMaterials = additionalMtrl;
        }
    }

    getLevel3Quantity() {
        let level = this.instruction.LevelInfo[2];
        if (level.CodeMaterials.length > 0)
            return level.QuantityInLevel * level.QuantityOfLevel;
        else
            return 0;
    }

    getLevel2Quantity() {
        let level = this.instruction.LevelInfo[1];
        if (level.CodeMaterials.length > 0)
            return level.QuantityInLevel * level.QuantityOfLevel;
        else
            return 0;
    }

    levelDataExists(level: number) {
        return this.instruction.LevelInfo[level].CodeMaterials.length > 0
            || this.instruction.LevelInfo[level].AdditionalMaterials.length > 0
    }

    onEditLevel(modal: any, level: number) {
        if (level < 3)
            this.hasSubLevelCode = this.instruction.LevelInfo[level + 1].PackagingCode != "";

        this.errHandler.emitErrorObject(null);
        this.editLevelData = this.instruction.LevelInfo[level];
        this.currentDlg = this.modalService.open(modal, { size: 'lg' });
    }

    onDeleteLevel(level: number) {
        let lvlInfo = this.instruction.LevelInfo[level];
        this.levelmh = [];
        if (level < 2) {
            for (var i = level; i < 2; i++) {
                let tempLevel = i;
                let levelinfo = this.instruction.LevelInfo[i + 1];
                this.instruction.LevelInfo[i] = levelinfo;
                this.instruction.LevelInfo[i].Level = tempLevel + 1;

                this.instruction.LevelInfo[i + 1] = new PkgInstrLevelInfo(i + 2);
            }
            this.info("Instruction Level Information has been deleted (if it contains any lower levels then they will become higher levels).");
        }
        else if(level == 2){
            let no = level + 1;
            this.instruction.LevelInfo[level] = new PkgInstrLevelInfo(no);
            this.info("Instruction Level Information has been deleted at Level " + no);
        }
        else {
           this.instruction.LevelInfo[level] = new PkgInstrLevelInfo(99);
           this.info("Common Material Information has been deleted.");
        }
        this.setQuantityInLevel();

            if (lvlInfo.AdditionalMaterials != null) {
                lvlInfo.AdditionalMaterials.forEach(insideelement => {
                    if (insideelement.MHNo != null) {
                        this.levelmh.push(insideelement.MHNo);
                    }
                })

            }

            if (lvlInfo.CodeMaterials != null) {
                lvlInfo.CodeMaterials.forEach(insideelement => {
                    if (insideelement.MHNo != null) {
                        this.levelmh.push(insideelement.MHNo);
                    }
                })
            }
        let mhNos = JSON.parse(localStorage.getItem("MhNumber"));

        if(mhNos != null && mhNos.length > 0){
        this.levelmh.forEach(element => {
           if (element != null) {
                mhNos = mhNos.filter(item => item !== element);
            }
            })
            localStorage.setItem("MhNumber", JSON.stringify(mhNos));
        }

    }

    deleteLevelCode(levelInfoIndex: number) {
        let tempAdditionalMaterials = this.instruction.LevelInfo[levelInfoIndex].AdditionalMaterials;
        this.instruction.LevelInfo[levelInfoIndex] = new PkgInstrLevelInfo(levelInfoIndex + 1);
        this.instruction.LevelInfo[levelInfoIndex].AdditionalMaterials = tempAdditionalMaterials;
    }

    onEditLevelDialogExecute(dialogResult: PkgInstrLevelInfo) {
        // RULE 0: nothing changed - do nothing
        if (dialogResult == null) {
            this.closeDlg();
            return;
        }

        this.closeDlg();
        this.setDirty();

        if (dialogResult.Level === 1 && dialogResult.ConstraintCodeId !== null) {
            // contraint code was selected. Set level 1 and get constraint code
            this.instruction.LevelInfo[0] = dialogResult;
            this.loadCodeConstraint(dialogResult.ConstraintCodeId, dialogResult.CodeId)
        }
        else if (dialogResult.Level === 1 && dialogResult.ConstraintCodeId === null) {
            // Code with no contraint selected on level 1
            // If the current code has a constraint, then remove any codes
            // but no additional materials on lower levels
            if (this.instruction.LevelInfo[0].ConstraintCodeId != null) {
                this.deleteLevelCode(1);
                this.deleteLevelCode(2);
            }
            this.instruction.LevelInfo[0] = dialogResult;

            // If the user deleted code, then deleta all codes on lower levels
            if (this.instruction.LevelInfo[0].PackagingCode.length === 0) {
                this.deleteLevelCode(1);
                this.deleteLevelCode(2);
                this.setQuantityInLevel();
                return;
            }
        }
        else if (dialogResult.Level === 2) {
            this.instruction.LevelInfo[1] = dialogResult;
            // If the user deleted code, then deleta all codes on lower levels
            if (this.instruction.LevelInfo[1].PackagingCode.length === 0) {
                this.deleteLevelCode(2);
            }
        }
        else if (dialogResult.Level == 3) {
            this.instruction.LevelInfo[2] = dialogResult;
        }
        else if (dialogResult.Level == 99) {
            this.instruction.LevelInfo[3] = dialogResult;
        }
        else {
            this.setQuantityInLevel();
            return;
        }

        this.setQuantityInLevel();
    }

    loadCodeConstraint(constraintCodeId: number, mainCodeId: number) {
        this.showSpinner = true;
        this.packInstrService.getLevelConstraintData(constraintCodeId, mainCodeId)
            .subscribe(returnObject => this.loadCodeConstraintResult(returnObject));
    }

    loadCodeConstraintResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadCodeConstraint', returnObject.ErrorType);
        else {
            let levelInfo: PkgInstrLevelInfo = returnObject.DataList[0];
            levelInfo.AdditionalMaterials = this.instruction.LevelInfo[1].AdditionalMaterials;
            levelInfo.Level = 2;

            this.instruction.LevelInfo[1] = levelInfo;
            this.setQuantityInLevel();
        }
        this.showSpinner = false;
    }

    // ----------------------------------------------------------
    // LongTerm
    // ----------------------------------------------------------

    loadPruList() {
        this.showUnitLoadingAnimation = true;
        this.packInstrService.getPruList()
            .subscribe(returnObject => this.loadPruListResponse(returnObject));

    }

    loadPruListResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadPruList', returnObject.ErrorType);
        else {
            this.pruList = returnObject.DataList;
            let pnldata = this.pruList.find(x => x.Description == "P&L");
            this.pruList =this.pruList.filter(item => item.Description !== "P&L");
            this.pruList.splice(0, 0, pnldata);
            let data = this.pruList.find(x => x.Description == "SL");
            this.pruList =this.pruList.filter(item => item.Description !== "SL");
            this.pruList.splice(1, 0, data); //Adding SL data after PnL
            this.instruction.PruRelations.filter(x => {
                this.pruList.find(y => y.Id == x.PruId).Selected = true;
            });

            PnL = this.pruList.find(x => x.Description == "P&L").Id;
            CW2 = this.pruList.find(x => x.Description == "SL").Id;
            CPC = this.pruList.find(x => x.Description == "CPC").Id;
        }
        this.showUnitLoadingAnimation = false;
    }

    uncheckPruItemRelations(clickedPruItem: AttributeListBE) {
        this.setDirty();
        if (this.partSuppPru == null)
            return;
        this.partSuppPru.forEach(item => {
            if (!clickedPruItem.Selected
                && item.PruMCCodeName == clickedPruItem.Description) {
                let index = this.instruction.PartRelations.findIndex(x => x.Id == item.Id);
                if (index != -1) {
                    this.instruction.PartRelations.splice(index, 1);
                    item.Selected = false;
                }
            }

        });
    }

    clearPruListSelections(): any {
        this.instruction.PruRelations = [];
        this.pruList.forEach(x => x.Selected = false);
        this.instruction.SendPreliminaryToMona = false;
        this.instruction.Region = 3;
    }

    clearSelectedRegion(): any{
      this.instruction.Region = 3;
    }


    updateSelectedPruItems() {
        if (this.isAtLeasOnePart()) {
            this.instruction.PruRelations = [];
            let partId = this.instruction.Parts[0].PartId;
            this.pruList.forEach(pruItem => {
                if (pruItem.Selected)
                    this.instruction.PruRelations.push(new PkgInstrPruRelationBE(pruItem.Id, this.instruction.Id, partId));
            });
        }
    }

    performPreSaveChecks() {
        this.showSpinner = true;
        this.updateSelectedPruItems();
        this.instruction.Region = this.selectedRegionValue;

        if (this.isAtLeasOnePart()) {
            let pkgInstrObjectToPost = this.preparePkgInstrToPost();
           // console.log("PruRelations[0] = " , this.instruction.PruRelations[0]);
            if(this.instruction.PruRelations[0].PruId === 114){
            this.packInstrService.isFirstPIWithSl(pkgInstrObjectToPost)
            .subscribe(responseObj => this.isFirstPIWithSlResponse(responseObj));
            }
            else if(this.instruction.PruRelations[0].PruId === 125)
            {
                this.packInstrService.isFirstPIWithCPC(pkgInstrObjectToPost)
                .subscribe(responseObj => this.isFirstPIWithCPCResponse(responseObj));
            }
            else {
            this.packInstrService.isFirstPIWithPnl(pkgInstrObjectToPost)
                .subscribe(responseObj => this.isFirstPIWithPnlResponse(responseObj));
            }
        }
        else
            this.chooseSaveType();
    }

    checkon :boolean=false;

    isFirstPIWithPnlResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg,
                'PackagingInstructionComponent.isFirstPIWithPnlResponse',
                returnObject.ErrorType);
        }
        else {
            if (returnObject.DataList[0] == true) {
                this.addPnlAndStsToPkgInstr();
                flagPnL = "P&L, ";
            }

            if(returnObject.DataList[0] == false){
                this.checkon=this.instruction.SendPreliminaryToMona;
                 this.addPnlAndStsToPkgInstr1();
             }

            let pkgInstrObjectToPost = this.preparePkgInstrToPost();
            this.packInstrService.checkConflict(pkgInstrObjectToPost)
                .subscribe(responseObj => this.checkConflictResponse(responseObj));
        }
    }


    isFirstPIWithSlResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg,
                'PackagingInstructionComponent.isFirstPIWithSlResponse',
                returnObject.ErrorType);
        }
        else {
            if (returnObject.DataList[0] == true) {
                this.addSlAndStsToPkgInstr();
                flagPnL = "SL,";
            }
            let pkgInstrObjectToPost = this.preparePkgInstrToPost();
            this.packInstrService.checkConflict(pkgInstrObjectToPost)
                .subscribe(responseObj => this.checkConflictResponse(responseObj));
        }
    }
    isFirstPIWithCPCResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg,
                'PackagingInstructionComponent.isFirstPIWithCPCResponse',
                returnObject.ErrorType);
        }
        else {
            if (returnObject.DataList[0] == true) {
                this.addCPCAndStsToPkgInstr();
                flagPnL = "CPC,";
            }
            let pkgInstrObjectToPost = this.preparePkgInstrToPost();
            this.packInstrService.checkConflict(pkgInstrObjectToPost)
                .subscribe(responseObj => this.checkConflictResponse(responseObj));
        }
    }


    checkConflictResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.checkConflict', returnObject.ErrorType);
        }
        else {
            this.activeConflictItemId = 0;
            this.conflictResponseObj = returnObject.DataList;

            //exclude NoConflict items
            this.conflictResponseObj = this.conflictResponseObj.filter(x => x.ConflictType != ConflictTypeEnum.NoConflict);

            if (this.conflictResponseObj.length == 0) {
                this.chooseSaveType();
            }
            else {
                this.currentConflictDlg = this.modalService.open(this.conflictPruDlg, {
                    size: 'sm',
                    backdrop: 'static',
                    keyboard: false
                });
                //this.chooseSaveType();
            }
        }
        this.showSpinner = false;
    }

    chooseSaveType() {
        if (this.sendToSupplierOrAccept == "activate")
            this.performSendForApproval();
        else
            this.saveInstruction();
    }

    performActionConflictDlg() {
        if (this.conflictResponseObj[this.activeConflictItemId].ConflictType == ConflictTypeEnum.LastUnitConflict) {
            this.packInstrService.UncheckPruRelationforPi(this.conflictResponseObj[this.activeConflictItemId], this.instruction.PIName)
                .subscribe(x => this.uncheckPruRelationforPiResponse(x));
            this.packInstrService.scrapPkgInstr(this.conflictResponseObj[this.activeConflictItemId].PkgInstrId)
                .subscribe(x => this.scrapPkgInstrResponse(x));
        }
        else if (this.conflictResponseObj[this.activeConflictItemId].ConflictType == ConflictTypeEnum.NormalUnitConflict) {
            this.packInstrService.UncheckPruRelationforPi(this.conflictResponseObj[this.activeConflictItemId], this.instruction.PIName)
                .subscribe(x => this.uncheckPruRelationforPiResponse(x));
        }
        else if (this.conflictResponseObj[this.activeConflictItemId].ConflictType == ConflictTypeEnum.DifferentLevelAssetsConflict) {
            this.cancelActionConflictDlg();
        }
    }

    cancelActionConflictDlg() {
        if (this.sendToSupplierOrAccept == "activate")
            this.closeSendApprovalDlg();
        this.currentConflictDlg.close();
    }

    updateConflictPopup() {
        this.activeConflictItemId++;
        if (this.activeConflictItemId == this.conflictResponseObj.length) {
            //to continue to show all conflict in a row to user.
            this.performPreSaveChecks();
            this.currentConflictDlg.close()
        }
    }

    uncheckPruRelationforPiResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.UncheckPruRelationforPi', returnObject.ErrorType);
        }
        else {
            this.updateConflictPopup();
            this.info("Conflicting unit relation is successfully unchecked.");
        }
    }

    scrapPkgInstrResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.scrapPkgInstr', returnObject.ErrorType);
        }
        else {
            this.updateConflictPopup();
            this.info("Conflicting Packaging Instruction is successfully scrapped.");
        }
    }

    addPnlAndStsToPkgInstr() {
        if (!this.isTherePnlInPkgInstr())
            this.instruction.PruRelations.push(new PkgInstrPruRelationBE(PnL, this.instruction.Id, this.instruction.Parts[0].PartId));
        this.instruction.SendPreliminaryToMona = true;
    }

    addSlAndStsToPkgInstr() {
        if (!this.isThereSlInPkgInstr())
            this.instruction.PruRelations.push(new PkgInstrPruRelationBE(CW2, this.instruction.Id, this.instruction.Parts[0].PartId));
        this.instruction.SendPreliminaryToMona = true;
    }
    addCPCAndStsToPkgInstr() {
        if (!this.isThereCPCInPkgInstr())
            this.instruction.PruRelations.push(new PkgInstrPruRelationBE(CPC, this.instruction.Id, this.instruction.Parts[0].PartId));
        this.instruction.SendPreliminaryToMona = true;
    }
    setSendToSystemFalse(){
      if(this.instruction.Region == 1)
      this.instruction.SendPreliminaryToMona = false;

    }

    addPnlAndStsToPkgInstr1()
    {
        if(this.checkon==true)
        {
            this.instruction.SendPreliminaryToMona=true;  
        }
        else
        {
        this.instruction.SendPreliminaryToMona = false;}
    }

    isTherePnlInPkgInstr(): boolean {
        return this.instruction.PruRelations.findIndex(x => x.PruId == PnL) == -1
            ? false
            : true;
    }

    isThereSlInPkgInstr(): boolean {
        return this.instruction.PruRelations.findIndex(x => x.PruId == CW2) == -1
            ? false
            : true;
    }
    isThereCPCInPkgInstr(): boolean {
        return this.instruction.PruRelations.findIndex(x => x.PruId == CPC) == -1
            ? false
            : true;
    }

    getPruName(pruid: number): string {
        return this.pruList.find(x => x.Id == pruid).Description;
    }

    // ----------------------------------------------------------
    // Pru/supplier list data
    // ----------------------------------------------------------
    loadSearchPruList() {
        this.showSupplierRelLoadingAnim = true;
        if (this.instruction.Parts.length > 0) {
            this.partSupplierPruService.searchPruByPruNameFor(this.instruction.Parts[0].PartNo)
                .subscribe(returnObject => this.loadSearchPruListResponse(returnObject));
        }
    }

    loadSearchPruListResponse(returnObject: IReturnObject) {
        this.errHandler.emitErrorObject(null);
        this.partSuppPru = null;
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadSearchPruListResponse', returnObject.ErrorType);
        } else {
            let isValid = this.isSupplierRelationResponseValid(returnObject);
            if (isValid) {
                this.partSuppPru = returnObject.DataList;
                let selPartRelations: PArray<PartSupplierPruBe> = new PArray(this.instruction.PartRelations);
                for (var i = 0; i < this.partSuppPru.length; i++) {
                    this.partSuppPru[i].Selected = selPartRelations.getItemByProperty('Id', this.partSuppPru[i].Id) != null;
                }
            }
        }
        this.showSupplierRelLoadingAnim = false;
    }

    isSupplierRelationResponseValid(returnObject: IReturnObject) {
        if (returnObject.DataList.length > 0) {
            if (returnObject.DataList[0].Id != null) {
                return true;
            }
        }
        return false;
    }

    setPartPkgRelation(psItem: PartSupplierPruBe) {
        let relationId = psItem.Id
        let pRelation: PArray<PartSupplierPruBe> = new PArray(this.partSuppPru);
        let inx = pRelation.getIndexByProperty('Id', relationId);
        let inx2 = this.partSuppPru.findIndex(x => x.Id == relationId);
        if (inx == null)
            return;

        this.partSuppPru[inx].Selected = !this.partSuppPru[inx].Selected;

       // Reset selected pru's in instruction from partSuppPru arrayd
        this.instruction.PartRelations = [];

        for (var i = 0; i < this.partSuppPru.length; i++) {
            if (this.partSuppPru[i].Selected)
                this.instruction.PartRelations.push(new PartSupplierPruBe(this.partSuppPru[i].Id));
        }

        //When supplier Relation selected, auto-select related pru.
        if (psItem.Selected) {
            this.pruList.find(x => x.Id == psItem.PruId).Selected = true;
        }
        //PAIT-333 start
        if (psItem.Selected)
        /*{
            this.DisableCheckbox(psItem,true);
        }
        else*/{
            this.DisableCheckbox(psItem,false);
        }
        //PAIT-333 end
        this.setDirty();
    }

DisableCheckbox(chk,prodisable)
{
    if(chk.PruMCCodeName=='SL'&& chk.SupplierNo=='784001')
            {
                for (var j = 0; j < this.partSuppPru.length; j++) {
                   if(this.partSuppPru[j].PruMCCodeName=='SL' && this.partSuppPru[j].Id !=chk.Id)
                   {
                    var element = <HTMLInputElement> document.getElementById("consumingArea"+this.partSuppPru[j].Id);
                    element.disabled = prodisable;
                   }
                }
            }
            else{
                for (var j = 0; j < this.partSuppPru.length; j++) {
                    if(this.partSuppPru[j].PruMCCodeName=='SL' && this.partSuppPru[j].SupplierNo =='784001')
                    {
                     var element = <HTMLInputElement> document.getElementById("consumingArea"+this.partSuppPru[j].Id);
                     element.disabled = prodisable;
                    }
                 }  
            }
}

DisableOtherSLCheckbox(chk)
{
        if (chk.Selected)
        {
            this.DisableCheckbox(chk,true);
        }
        else{
            this.DisableCheckbox(chk,false);
        }
}

    // ----------------------------------------------------------
    // Other info
    // ----------------------------------------------------------
    addOtherInfo() {
        if (this.instruction.Comment.length == 0)
            this.instruction.Comment = this.newOtherInfo;
        else
            this.instruction.Comment = this.instruction.Comment + '|' + this.newOtherInfo;
        this.otherInfos = this.instruction.Comment != null ? this.instruction.Comment.split("|") : "".split("|");
        this.newOtherInfo = '';
        this.isDirty = true;
    }

    deleteOtherInfo(textToFind: string) {
        var inx = this.otherInfos.indexOf(textToFind);
        this.otherInfos.splice(inx, 1)
        this.instruction.Comment = this.otherInfos.length > 0 ? this.otherInfos.join('|') : '';
        this.isDirty = true;
    }

    moveInfoTextUp(infoText: string) {
        this.moveInfoText(infoText, -1);
    }

    moveInfoTextDown(infoText: string) {
        this.moveInfoText(infoText, 1);
    }

    moveInfoText(infoText: string, steps: number) {
        let inx: number = this.otherInfos.indexOf(infoText);
        let newInx = (inx + steps) < 0 ? 0 : inx + steps;
        this.otherInfos.splice(inx, 1);
        this.otherInfos.splice(newInx, 0, infoText);
        this.instruction.Comment = this.otherInfos.length > 0 ? this.otherInfos.join('|') : '';
        this.isDirty = true;
    }

    updateOtherInfo() {
        this.instruction.Comment = "";
        this.otherInfos.forEach(x => {
            if (this.instruction.Comment == "")
                this.instruction.Comment = x;
            else
                this.instruction.Comment = this.instruction.Comment + "|" + x;
        });
    }
    validateMhInLevel(): boolean {
        this.Mhnumber = [];

        this.instruction.LevelInfo.forEach(element => {
            if (element.AdditionalMaterials != null) {
                element.AdditionalMaterials.forEach(insideelement => {
                    if (insideelement.MHNo != null) {
                        this.Mhnumber.push(insideelement.MHNo);
                    }
                })
            }
        })
        this.instruction.LevelInfo.forEach(element => {
            if (element.CodeMaterials != null) {
                element.CodeMaterials.forEach(insideelement => {
                    if (insideelement.MHNo != null) {
                        this.Mhnumber.push(insideelement.MHNo);
                    }
                })
            }
        })
        let findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) != index)
        let duplicateValues = findDuplicates(this.Mhnumber)
        if (duplicateValues.length > 0) {
            if (duplicateValues.every(v => this.Exclusionlist.includes(v))) {
                return true;

            } else {
                // this.openOnSaveValidateDlg("Same material " + duplicateValues + " cannot be added in same Packaging Instruction more than once");
                return false;
            }
        } else { return true; }
    }

    validQuantity(): boolean {
        var checkCodeMaterialsQuantity: boolean = true;
        var checkAdditionalMaterialsQuantity: boolean = true;
        this.instruction.LevelInfo.forEach(element => {
            if (element.AdditionalMaterials != null) {
                element.AdditionalMaterials.forEach(insideelement => {
                    if (insideelement.Quantity == 0) {
                        checkAdditionalMaterialsQuantity = false;
                    } else {
                        checkAdditionalMaterialsQuantity = true;
                    }
                })
            }
        })
        this.instruction.LevelInfo.forEach(element => {
            if (element.CodeMaterials != null) {
                element.CodeMaterials.forEach(insideelement => {
                    if (insideelement.Quantity == 0) {
                        checkCodeMaterialsQuantity = false;
                    } else {
                        checkCodeMaterialsQuantity = true;
                    }
                })
            }
        })
        if (checkAdditionalMaterialsQuantity && checkCodeMaterialsQuantity)
            return true;
        else
            return false;

    }

    findCommonElements(arr1, arr2) {
        return arr1.some(item => arr2.includes(item))
    }

    getMaterialExclusions() {
        this.materialAttrService.getMaterialExclusions()
            .subscribe(returnObject => {
                this.fillExclusionList(returnObject.DataList);

            });

    };
    fillExclusionList(dataList: AttributeListBE[]) {
        dataList.forEach(element => {
            if (element.MHno != null) {
                this.Exclusionlist.push(element.MHno)
            }
        })
    }

    customTrackBy(index: number, obj: any): any {
        return index;
    }

    // ----------------------------------------------------------
    // searchPart methods
    // ----------------------------------------------------------
    addPartToInstruction(part: PartListBE): void {
        this.closeDlg();

        if (part == null)
            return;
        else
            this.clearPruListSelections();

        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.partSupplierPruService.getPart(part.Id)
            .subscribe(returnObject => this.addPartToInstructioResult(returnObject, part));
    }

    addPartToInstructioResult(returnObject: IReturnObject, part: PartListBE): void {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            if (returnObject.ErrorType == ErrorTypeEnum.Warning)
                this.getPartInfo(part.Id);
            else
                this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.addPartToInstructioResult', returnObject.ErrorType);


        }
        else {
            let partPruSuppList: Array<PartSupplierPruBe> = returnObject.DataList;
            let newPart = new PackageIntructionPart();
            newPart.Id = partPruSuppList[0].Id;
            newPart.PartId = partPruSuppList[0].PartId;
            newPart.PartNo = partPruSuppList[0].PartNo;
            newPart.Description = partPruSuppList[0].PartShortDescription;
            newPart.Weight = partPruSuppList[0].Weight;
            newPart.WeightCode = partPruSuppList[0].WeightCode;
            newPart.IsMultiPart = part.IsMultiPart;
            this.instruction.Parts.push(newPart);
            this.instruction.PIName = `${partPruSuppList[0].PartNo}-${partPruSuppList[0].PartShortDescription}`;
            this.loadPruList();
            this.loadSearchPruListResponse(returnObject);
            this.loadExistingConsistingParts(partPruSuppList[0].PartNo);
            this.checkNameUnique();
            this.setQuantityInLevel();
            this.findUserPruId();


            if (this.instruction.Pictures == null || this.instruction.Pictures.length == 0) {
                this.pictureLabels = newPart.PartNo;
                this.PITitle = newPart.PartNo;
            }
        }
        this.isDirty = true;
        this.showSpinner = false;
    }

    getPartInfo(partId: number) {
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
        this.partSupplierPruService.getPartInfo(partId)
            .subscribe(returnObject => this.getPartInfoResponse(returnObject));
    }

    getPartInfoResponse(returnObject: IReturnObject): void {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.addPartToInstructioResult', returnObject.ErrorType);
        }
        else {
            let newPart: PackageIntructionPart = returnObject.DataList[0];
            this.instruction.Parts.push(newPart);

            this.instruction.PIName = newPart.Description == undefined
                ? `${newPart.PartNo}`
                : `${newPart.PartNo}-${newPart.Description}`;
            this.loadExistingConsistingParts(newPart.PartNo);
            this.checkNameUnique();
            this.setQuantityInLevel()
            this.loadPruList();
            this.findUserPruId();

            if (this.instruction.Pictures == null || this.instruction.Pictures.length == 0) {
                this.pictureLabels = newPart.PartNo;
                this.PITitle = newPart.PartNo;
            }
        }
        this.isDirty = true;
        this.showSpinner = false;
    }


    loadExistingConsistingParts(partNo: string) {
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
        this.multiPartService.getConsistingPartsForPart(partNo)
            .subscribe(returnObject => this.loadExistingConsistingPartsResponse(returnObject));
    }

    loadExistingConsistingPartsResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructionComponent.loadExistingConsistingPartsResponse', returnObject.ErrorType);
        else {
            if (this.instruction.Parts.length > 0) {
                this.instruction.Parts[0].ConsistingParts = null;
                this.instruction.Parts[0].ConsistingParts = returnObject.DataList;
            }
        }

    }


    // ----------------------------------------------------------
    // Dialog boxes and support methods
    // ----------------------------------------------------------
    openOnSaveValidateDlg(text: string) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "savefail";
        this.dialogBtnType = "info";
        this.dialogAppliesTo = 'Package Instruction';
        this.confirmDlgText = text;
        this.dialogAppliesToId = this.instruction.Id;
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
    }

    openOnSendMailValidateDlg(text: string) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "savefail";
        this.dialogBtnType = "info";
        this.dialogAppliesTo = 'Package Instruction';
        this.confirmDlgText = text;
        this.dialogAppliesToId = this.instruction.Id;
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'lg' });
    }

    openConfirmDeleteDlg() {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "delete";
        this.dialogBtnType = "danger";
        this.dialogAppliesTo = 'Package Instruction';
        this.dialogAppliesToId = this.instruction.Id;
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
    }

    onDeletePart(partId: number) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "deletepart";
        this.dialogAppliesToId = partId;
        this.dialogAppliesTo = 'part';
        this.dialogBtnType = "danger";
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
    }

    confirmContinueWithoutSave() {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "continuewithoutsave";
        this.dialogBtnType = "warning";
        this.dialogAppliesTo = 'Package Instruction';
        this.dialogAppliesToId = this.instruction.Id;
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
    }

    onSearchPart(modal: any) {
        this.errHandler.emitErrorObject(null);
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
        if (this.isAtLeasOnePart())
            this.currentDlg.close();
    }

    onConfirmDlgNotify(command: ConfirmResult): void {
        if (command.Action == "delete")
            this.deleteInstruction();

        else if (command.Action == "deletepart")
            this.deletePart(command.Id);

        else if (command.Action == "continuewithoutsave") {
            this.currentDlg.close();
            if (this.pendingAction != null)
                this.pendingAction();
        }
        else if (command.Action == "cancel") {
            this.pendingAction = null;
            this.currentDlg.close();
        }
        else
            this.currentDlg.close();
    }


    // ----------------------------------------------------------
    // Button bar and support methods
    // ----------------------------------------------------------
    onBtnBarButtonNotify(command: string): void {
        if (command == "new") {
            this.pendingAction = this.newPi;
            this.countinueWithoutSave();
        }
        if (command == "preview")
            this.previewInstruction();

        else if (command == "save" && this.isContentValid()) {
            //this.instruction.SendPreliminaryToMona = true;
            this.performPreSaveChecks();
        }

        else if (command == "duplicate") {
            this.pendingAction = this.duplicatePi;
            this.countinueWithoutSave();
        }

        else if (command == "approve" && this.isContentValidForApprove()) {
            this.checkSupplierContactsExist();
        }

        else if (command == "history")
            this.viewHistory();

        else if (command == "delete") {
            this.openConfirmDeleteDlg();
        }
    }

    //PAIT-814
    previewInstruction() {
        let change1 :string;
        change1=this.instruction.PIName.replace(/"/g,' ');
        this.packInstrService.getPreviewPdf(this.instruction.Id, change1)
            .subscribe(returnObject => this.previewInstructionResponse(returnObject));
    }
 
    previewInstructionResponse(returnObject: any) {
        let change :string;
        change=this.instruction.PIName.replace(/"/g,' ');
        window.open(this.config.get('apiUrl') + "/PackaginInstruction/GetPreviewPdf/?piId=" + this.instruction.Id + "&piName=" + change, '_blank');
    }

    // previewInstruction() {
    //     this.packInstrService.getPreviewPdf(this.instruction.Id, this.instruction.PIName)
    //         .subscribe(returnObject => this.previewInstructionResponse(returnObject));
    // }

    // previewInstructionResponse(returnObject: any) {
    //     window.open(this.config.get('apiUrl') + "/PackaginInstruction/GetPreviewPdf/?piId=" + this.instruction.Id + "&piName=" + this.instruction.PIName, '_blank');
    // }

    viewHistory() {
        this.errHandler.emitErrorObject(null);
        this.showHistorySpinner = true;
        this.currentDlg = this.modalService.open(this.historyDlg, { size: 'lg' });

        this.loadHistory();
    }

    duplicatePi: any = () => {
        this.pendingAction = null;
        this.createDuplicate();
    }

    newPi: any = () => {
        this.pendingAction = null;
        this.setNewInstructionData();
    }

    loadPi: any = () => {
        this.pendingAction = null;
        this.loadInstruction();
    }

    clickSendForApproval() {
      this.closeDlg();//it prevents error
      //check for Supplier email
        sendToSupplierVerified = this.isContentValidforSend();
        if (sendToSupplierVerified){
            if (this.sendToSupplierOrAccept == "activate") {
            this.setDirty();
            if(this.instruction.Region != 1){
              this.instruction.SendPreliminaryToMona = true//it's needed to conflict check
            }
            this.performPreSaveChecks();
            }
            else if (this.sendToSupplierOrAccept == "send") {
                this.performSendForApproval();
            }
        }
    }

    performSendForApproval() {
        if (this.sendToSupplierOrAccept == "activate")
            this.instruction.StatusId = StatusEnum.Active;
        this.setInstructionStartEndDate();
        this.approveInstruction();
        this.closeSendApprovalDlg();
    }

    countinueWithoutSave() {
        if (this.isDirty)
            this.confirmContinueWithoutSave();
        else
            this.pendingAction();
    }


    // ----------------------------------------------------------
    // PI save and approve validation
    // ----------------------------------------------------------
    isContentValid(): boolean {
        if (!this.isValidNPIName()) {
            this.openOnSaveValidateDlg("Instruction name has to be at least seven (" + MIN_NAME_LENGTH + ") characters long");
            return false;
        }
        //PAIT-333
        if (!this.isValidSLUnit()) {
            this.openOnSaveValidateDlg("You cannot select both Internal and External SL Supplier in the same PI");
            return false;
        }

        if (!this.isValidConsumingAres()) {
            // this.openOnSaveValidateDlg("One or more consuming area needs to be selected, please select before saving");
            this.openOnSaveValidateDlg("One or more unit needs to be selected, please select before saving");
            return false;
        }

        else if (!this.isValidNumericValues()) {
            this.openOnSaveValidateDlg("One or more of the characters in deviation fields are no numeric, please correct before save");
            return false;
        }

        else if (!this.isValidOtherInfo()) {
            this.openOnSaveValidateDlg("Other info is not correct, plase fix xxxxx");
            return false;
        }

        else if (!this.isValidLevelData()) {
            this.openOnSaveValidateDlg("Please select atleast One Level !");
            return false;
        }

        else if (!this.isValidExclusionData()) {
            this.openOnSaveValidateDlg("Same Material can't be present multple times in One Packaging Instruction !");
            return false;
        }

        else if (!this.isValidQuantityData()) {
            this.openOnSaveValidateDlg("Quantity cannot be zero");
            return false;
        }

        else if (!this.isValidDates()) {
            this.openOnSaveValidateDlg("Please enter valid startdate.")
            return false;
        }

        // else if (!this.isThereSLInInstr()) {
        //     this.openOnSaveValidateDlg("Please make sure that Packaging code longer than 2 is only selected for SL-Internal.")
        //     return false;
        // }

        else if (!this.isValidPackagingCode() || !this.isThereOnlyUnitsInInstr()) {
            this.openOnSaveValidateDlg("Packaging code longer than 2 is not allowed unless only units CPC or SL is selected.")
            return false;
        }


        return true;
    }

    isContentValidforSend(): boolean {

        //PAIT-24: check for Supplier PRu selected has contact available
        if (this.partSuppPru != null) {
            for (var i = 0; i < this.partSuppPru.length; i++) {
                if (this.partSuppPru[i].Selected == true && this.partSuppPru[i].SupplierNo != "0000000") {
                    var isSparePart = this.partSuppPru[i].IsSparePart;
                    var suppId = this.partSuppPru[i].SupplierNo + "- " + this.partSuppPru[i].SupplierName;
                    var iscountofemailExists = this.partSuppPru[i].countofemailExists;
                    var isPruProd = "";
                    if (isSparePart)
                        isPruProd = "Parts Logistics";
                    else
                        isPruProd = "Production";

                    if (iscountofemailExists == 0) {
                        this.openOnSendMailValidateDlg("There is no Supplier contact mapped to " + isPruProd + " for Supplier " + suppId + ", Please add a supplier contact under Administration, Supplier setting.");
                        return false;
                    }
                    //now check if the pru has contact mapped as per isPartProduction
                    /* if (this.sendForApprovalSuppliers != null) {
                         for (var i = 0; i < this.sendForApprovalSuppliers.length; i++)
                         {
                             if (this.sendForApprovalSuppliers[i].PruId == pruid)
                             {
                                 var contactexists ;
                                 if(isSparePart)
                                 contactexists = this.sendForApprovalSuppliers[i].IsSparePart

                             }
                         }
                     }  */
                }
            }
        }

        return true;
    }


    isContentValidForApprove(): boolean {
        if (!this.isContentValid())
            return false;

        // In long term it is possible to activate PI even it does not have supplier relation
        // if (!this.isValidPartForApproval()) {
        //     return false;
        // }

        if (!this.isPartActive()) {
            return false;
        }

        return true;
    }

    //[] is it changed after long-term? is PartRelations still needed?
    isValidPartForApproval(): boolean {
        // to be possible to approve there must be one part and at least one consuming are
        var isValid = this.instruction.Parts != null
            && this.instruction.Parts.length > 0
            && this.instruction.PartRelations != null
            && this.instruction.PartRelations.length > 0;

        if (!isValid)
            this.openOnSaveValidateDlg("At least one part and one conuming area has to\nbe selected and saved before approval.");

        return isValid;
    }

    isPartActive(): boolean {
        // customer decided to disable this check.
        // Remove next line return false if customer change their mind
        return true;
    }

    isValidDates(): boolean {
        /**
         * Start date must be selected for approval flow.
         */
        var isValid = this.startDate === null ? false : true;

        if (isValid) {
            if ((this.startDate.year != null
                && this.startDate.month != null
                && this.startDate.day != null) == true) {
                return true;
            }
            return false;
        }
        return false;
    }

    isValidPackagingCode(): boolean {
      /**
         * Start date must be selected for approval flow.
         */ 
       // debugger;       
       let tempInstr: PackageInstructionItem = this.preparePkgInstrToPost();
       var isValid = true;
       var supplierstring = "784001";
       //check 784001 supplier if yes add internal
       // if (this.partSuppPru != null) {
       //     var isValue = this.partSuppPru.find(x => x.SupplierNo != supplierstring && x.Selected == true);
       //     if (isValue) {
       //         console.log(this.partSuppPru);
       //         this.partSuppPru.forEach(item => {
       //             if (item.SupplierNo != supplierstring && item.Selected == true) {
       //                 this.pruList.forEach(pruitem => {
       //                     tempInstr.LevelInfo.forEach(instr => {
       //                         if (instr.PackagingCode.length > 2) {
       //                             if (instr.Level == 1 || (pruitem.Description != "SL" && pruitem.Selected == true)||(pruitem.Description != "CPC" && pruitem.Selected == true)) {
       //                                 isValid = false;
       //                             }
       //                         }
       //                     });
       //                 });
       //                 // tempInstr.LevelInfo.forEach(instr => {
       //                 //     if (instr.Level == 1 && instr.PackagingCode.length > 2) {
       //                 //         isValid = false;
       //                 //     }
       //                 // });
       //             }

       //         });
       //     }
       //   console.log(this.pruList);
       if (this.pruList != null) {
        this.pruList.forEach(item => {
            tempInstr.LevelInfo.forEach(instr => {
                if(instr.PackagingCode.length > 2 && item.Selected==true && item.Description!='SL'&& item.Description!='CPC')
                {
                    isValid=false;
                }
                //     if (instr.Level == 1 && instr.PackagingCode.length > 2 && item.Selected == true&& item.Description != 'SL'&& item.Description != 'CPC') {
            //         isValid = false;
            //     }
            //     else if ((instr.Level == 2 || instr.Level == 3) && instr.PackagingCode.length > 2 && item.Selected == true && item.Description != 'SL'&& item.Description != 'CPC') {
            //         isValid = false;
            //     }
             });               
        });
    }

       return isValid;
      
        
    }
    isThereSLInInstr(): boolean {
        var isExists = true;
        var supplierstring = "784001";
        let tempInstr: PackageInstructionItem = this.preparePkgInstrToPost();
        //check 784001 supplier if yes add internal
        if (this.partSuppPru != null) {
            var isValue = this.partSuppPru.find(x => x.SupplierNo == supplierstring && x.Selected == true);
            if (isValue) {
                this.partSuppPru.forEach(item => {
                    if (item.SupplierNo == supplierstring && item.Selected == true) {
                        this.pruList.forEach(item => {
                            tempInstr.LevelInfo.forEach(instr => {
                                if (instr.PackagingCode.length > 2) {
                                    if (item.Description != "SL" && item.Selected == true) {
                                        isExists = false;
                                    }
                                }
                            });
                        });
                    }

                });
            }
        }

        return isExists;
    }

    isThereOnlyUnitsInInstr(): boolean {
        let tempInstr: PackageInstructionItem = this.preparePkgInstrToPost();
        var isValid = true;
        if (this.partSuppPru != null) {
            var isValue = this.partSuppPru.find(x => x.Selected == true);
            if (!isValue) {
                this.pruList.forEach(item => {
                    if (item.Selected == true) {
                        tempInstr.LevelInfo.forEach(instr => {
                            if (instr.Level == 1 && instr.PackagingCode.length > 2 && item.Description != 'SL'&&item.Description!='CPC' ) {
                                isValid = false;
                            }
                            else if ((instr.Level == 2 || instr.Level == 3) && instr.PackagingCode.length > 2 && item.Description != 'SL'&&item.Description!='CPC') {
                                isValid = false;
                            }
                        });
                    }

                });
            }
        }

        return isValid;
    }

    isValidOtherInfo(): boolean {
        // TODO validations ??
        return true;

    }


      //If the region is selected then the user should not be able to select supplier
      //The send to system checkbox should not be checked as well which means he conflict logic does not apply here
      //You can have as much duplicates as you want

    isValidLevelData(): boolean {
        if (this.instruction.LevelInfo[0].PackagingCode.length > 0
            && this.instruction.LevelInfo[0].CodeMaterials.length > 0) {
            return true;
        }
        else
            return false;
    }

    isValidExclusionData(): boolean {
        if (this.validateMhInLevel()) {
           // localStorage.clear();
            return true;
        }
        else
          //localStorage.clear();
        return false;
    }

    isValidQuantityData(): boolean {
        if (this.validQuantity()) {
            return true;
        }
        else {
            false;
        }
    }

    //[]Is it right?
    isValidConsumingAres(): boolean {
        // If a part is selected then one or more consuming areas has to be
        // checked because the part and part cannot be saved in db without it
        // if (this.instruction.Parts != null && this.instruction.Parts.length > 0)
        //     return this.instruction.PartRelations != null && this.instruction.PartRelations.length > 0;

        return this.isAtLeasOnePart() == true
            ? this.pruList != null && this.pruList.filter(x => x.Selected == true).length > 0
            : true;
    }

    isValidNumericValues(): boolean {
        let checkValues: boolean = Number.isNaN(this.instruction.DeviationHeight)
            || Number.isNaN(this.instruction.DeviationLength)
            || Number.isNaN(this.instruction.DeviationWeight)
            || Number.isNaN(this.instruction.DeviationWidth)
            || Number.isNaN(this.instruction.DeviationHeight)
        return !checkValues;
    }

    isValidNPIName(): boolean {
        return this.instruction.PIName.length >= MIN_NAME_LENGTH;
    }
    //PAIT -333
    isValidSLUnit(): boolean {
        debugger;
        var validSL=true;
        var SLselected_Internal=0;
        var SLselected_External=0;
        if(this.partSuppPru == null || this.partSuppPru.length === 0)
          validSL=true;
        else
        {
            for (var i = 0; i < this.partSuppPru.length; i++) {
                if (this.partSuppPru[i].Selected)
                {
                    if(this.partSuppPru[i].PruMCCodeName=='SL' && this.partSuppPru[i].SupplierNo!='784001')
                    {
                        SLselected_External++;
                    }   
                    if(this.partSuppPru[i].PruMCCodeName=='SL' && this.partSuppPru[i].SupplierNo=='784001')
                    {
                        SLselected_Internal++;
                    }              
                }
    
            }
            if(SLselected_External>0&& SLselected_Internal==1)
            {
                        validSL=false;
            }
            else{
                        validSL=true;
            }
        }
        return validSL;
        }

    // ----------------------------------------------------------
    // info
    // ----------------------------------------------------------
    info(message: string): void {
        this.errHandler.emitError(message, '', ErrorTypeEnum.Info);
    }


    // ----------------------------------------------------------
    // Image Modals
    // ----------------------------------------------------------
    openAddImageToPI(modal: any) {
        this.currentDlg = this.modalService.open(modal, { size: 'lg' });
    }

    openDeleteImageFromPI(modal: any, pictureInfo: any) {
        this.deleteImageInfo = pictureInfo;
        this.currentDlg = this.modalService.open(modal, { size: 'sm' });
    }

    closeAddImageDlg() {
        this.imageSearchResult = [];
        this.selectedImages = [];
        this.currentDlg.close();
    }

    closeDeleteImageDlg() {
        this.currentDlg.close();
    }

    countChange(event: PictureBe) {
        this.imageLibraryEvent = <PictureBe>event;
        this.selectImageToInstr(this.imageLibraryEvent);
    }


    // ----------------------------------------------------------
    // MISC
    // ----------------------------------------------------------
    onLevelDataChanged() {
        this.setDirty();
    }

    setDirty() {
        this.isDirty = true;
    }

    closeDlg() {
        this.currentDlg.close();
    }

    closeSendApprovalDlg() {
        this.currentDlg.close();
        this.sendToSupplierOrAccept = "";
    }


    // ----------------------------------------------------------
    // Check if pi name exists when typing
    // ----------------------------------------------------------
    checkNameUnique()
     {
        if (this.instruction.PIName.length < MIN_NAME_LENGTH) {
            this.nameExistsClass = "";
            return;
        }

        if (this.instruction.PIName == this.orgName) {
            this.nameExistsClass = "";
            return;
        }

        this.packInstrService.piNameExist(this.instruction.PIName)
            .subscribe(nameExists => this.checkNameUniqueResponse(nameExists));
    }

    checkNameUniqueResponse(nameExists: boolean) {
        this.nameExistsClass = nameExists
            ? "nameExist"
            : "";
    }

    setDefaultBackColor() {
        this.nameExistsClass = "";
    }


    // ----------------------------------------------------------
    // Send for appoval
    // ----------------------------------------------------------
    prepareApprovalDlg() {
        this.sendForApprovalSuppliers = [];
        this.sendToSupplierOrAccept = "send";
        this.approvalMessage = "";
        if (this.partSuppPru != null) {
            for (var i = 0; i < this.partSuppPru.length; i++) {
                if (this.sendForApprovalSuppliers.findIndex(x => x.SupplierNo == this.partSuppPru[i].SupplierNo) == -1) {
                    let supp: PartSupplierPruBe = new PartSupplierPruBe(0);
                    supp.SupplierName = this.partSuppPru[i].SupplierName;
                    supp.SupplierNo = this.partSuppPru[i].SupplierNo;
                    supp.PruId = this.partSuppPru[i].PruId;
                    supp.IsSparePart = this.partSuppPru[i].IsSparePart;
                    supp.countofemailExists = this.partSuppPru[i].countofemailExists;
                    var suppSelectedCheck = this.partSuppPru.find(x => x.SupplierNo == supp.SupplierNo && x.Selected == true);
                    supp.Selected = suppSelectedCheck != null;
                    this.sendForApprovalSuppliers.push(supp);

                }
            }
        }
    }

    isAnyApproveSupplierSelected(): boolean {
        return this.sendForApprovalSuppliers.findIndex(x => x.Selected == true) == -1;

    }


    // ----------------------------------------------------------
    // GUI behaviour
    // ----------------------------------------------------------
    toggleSupplierPanel() {
        this.supplierListVisible = !this.supplierListVisible;
    }

    togglePartsPanel() {
        this.partListVisible = !this.partListVisible;
    }

    togglePrusPanel() {
        this.pruListVisible = !this.pruListVisible;
    }

    isNewOtherInfoEmpty(): boolean {
        return this.newOtherInfo.length == 0 || this.isEditDisabled();
    }

    isPartNotNull(partInfo: PackageIntructionPart): boolean {
        return partInfo !== null && this.instruction.Parts.length == 0;
    }

    isAtLeasOnePart(): boolean {
        return this.instruction.Parts != null && this.instruction.Parts.length > 0;
    }

    isFirstOtherInfoReocord(infoText: string): boolean {
        return this.otherInfos.indexOf(infoText) == 0;
    }

    isLastOtherInfoReocord(infoText: string): boolean {
        return this.otherInfos.indexOf(infoText) == this.otherInfos.length - 1;
    }


    // ----------------------------------------------------------
    // Access rights
    // ----------------------------------------------------------
    isEditLevelButtonDisabled(level: number): boolean {
        let ruleResult: boolean = false;

        // prevent checks from being run until leveldata has been populated
        if (this.instruction.LevelInfo == null || this.instruction.LevelInfo.length < 4) {
            return true;
        }

        if (level == 0) {
            return this.isEditDisabled();
        }

        if (level == 1) {
            return this.instruction.LevelInfo[0].PackagingCode.length == 0 || this.isEditDisabled();
        }

        if (level == 2) {
            return this.instruction.LevelInfo[1].PackagingCode.length == 0 || this.isEditDisabled();
        }

        if (level == 3) {
            return this.isEditDisabled();;
        }
    }

    isDeleteLevelButtonDisabled(level: number): boolean {
        let ruleResult: boolean = false;

        // prevent checks from being run until leveldata has been populated
        if (this.instruction.LevelInfo == null) {
            return false;
        }

        if (level == 0) {
            return this.instruction.LevelInfo[0].PackagingCode.length == 0 || this.isEditDisabled();
        }

        if (level == 1) {
            return this.instruction.LevelInfo[1].PackagingCode.length == 0 || this.isEditDisabled();
        }

        if (level == 2) {
            return this.instruction.LevelInfo[2].PackagingCode.length == 0 || this.isEditDisabled();
        }

        if (level == 3) {
            return this.instruction.LevelInfo[3].AdditionalMaterials.length == 0 || this.isEditDisabled();;
        }
    }


    isBtnBarHidden(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsScaniaUser
                || this.user.IsTestPackager
                || this.user.IsPartSupplierUser
                || this.user.IsDeveloper)
            && this.instructionIdFromParentCtrl == null;

        return !gotAccess;
    }

    isBtnNewDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsDeveloper);

        return !gotAccess;
    }

    isBtnDuplicateDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsDeveloper)
            && this.instruction != null;

        return !gotAccess;
    }

    isBtnPreviewDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsPartSupplierUser
                || this.user.IsPurchaser
                || this.user.IsScaniaUser
                || this.user.IsDeveloper)
            && !this.isDirty // must be saved to be able to view PDF
            && this.instruction != null;

        return !gotAccess;
    }

    isBtnSaveDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsDeveloper)
            && this.isDirty
            && this.instruction != null
            && (this.instruction.StatusId == StatusEnum.Preliminary
                || this.instruction.StatusId == StatusEnum.Active)
            && this.nameExistsClass != "nameExist"
            && this.instruction.Parts.length != 0;

        return !gotAccess;
    }

    isBtnApproveDisabled(): boolean {
        let gotAccess: boolean =
            ((this.user.IsPackagingAdmin && this.user.IsScaniaApprover)
                || (this.user.IsPackagingEngineer && this.user.IsScaniaApprover)
                || this.user.IsDeveloper)
            && this.instruction != null
            && this.instruction.StatusId == StatusEnum.Preliminary
            && !this.isDirty // must be saved before approval
            && this.nameExistsClass != "nameExist";

        return !gotAccess;
    }

    isBtnHistoryDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsDeveloper
                || this.user.IsScaniaUser)
            && this.instruction != null
            && this.instruction.Id != -1;
        return !gotAccess;
    }

    isBtnDeleteDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsDeveloper)
            && this.instruction != null
            && this.instruction.Id > 0
            && this.instruction.StatusId == StatusEnum.Preliminary;

        let gotAdminAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsDeveloper)
            && this.instruction != null
            && this.instruction.Id > 0
            && this.instruction.StatusId > StatusEnum.Preliminary;

        return !(gotAccess || gotAdminAccess);
    }

    isSearchHidden(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsPurchaser
                || this.user.IsTestPackager
                || this.user.IsPartSupplierUser
                || this.user.IsDeveloper
                || this.user.IsScaniaUser)
            && this.instructionIdFromParentCtrl == null;

        return !gotAccess;
    }

    isEditDisabled(): boolean {
        let gotAccess: boolean =
            (this.user.IsPackagingAdmin
                || this.user.IsPackagingEngineer
                || this.user.IsTestPackager
                || this.user.IsDeveloper)
            && this.instructionIdFromParentCtrl == null
            && this.instruction != null
            && this.instruction.StatusId == StatusEnum.Preliminary;

            //console.log(gotAccess);

        return !gotAccess;
    }

    //PAIT-333 start
    findUserPruId(){
    if(!this.user.IsPartSupplierUser)
    this.pruUserService.getPruUser(this.user.UserId)
    .subscribe(returnObject => this.findUserPruIdResponse(returnObject));
     }
    findUserPruIdResponse(returnObject: IReturnObject) {
//    debugger; 
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PruUserComponent.findUserPruIdResponse', returnObject.ErrorType);
        else {
            let foundUser: UserPruBE = returnObject.DataList[0];
            this.selectedPruUser = new UserPruBE();
            this.selectedPruUser.PruId = foundUser.PruId;
        }
        //PAIT-333 end
    }
    isEditConsumingArea(ConsumingAreaId :string, pruID: any): boolean {
        //PAIT-333
        if(this.flag! === 1)
        {
          this.findUserPruId();
          this.flag === 1;
        }
        let SLPruId: number =this.selectedPruUser.PruId;
        let gotAccess: boolean = (this.user.IsPackagingAdmin
            || this.user.IsPackagingEngineer
            || this.user.IsTestPackager
            || this.user.IsDeveloper
            ||this.user.IsScaniaUser
            )
            && this.instructionIdFromParentCtrl == null
            && this.instruction != null
            && (this.instruction.StatusId == StatusEnum.Preliminary
                || this.instruction.StatusId == StatusEnum.Active)
            && ((SLPruId != 114 && pruID != 114) || (SLPruId == 114))
  // && ((ConsumingAreaId=='Supplier' && SLPruId==pruID || SLPruId==114)|| ConsumingAreaId=='Unit' || pruID=='unit')
       //console.log("value of access is "+gotAccess+"  and opposite will be returned"+!gotAccess);
  return !gotAccess;
    }

    isSupplierWithNoSuppNo(): boolean {
        return this.user.IsPartSupplierUser
            && (this.user.SupplierNumber == null || this.user.SupplierNumber == "0");
    }

    onAddOtherInfo(event) {
        if (event.key === "Enter") {
            this.addOtherInfo();
        }
    }

}




// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/packaging-instruction/packaging-instruction.component.ts